import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export function AuthLayout() {
  const { user, loading } = useAuthStore();

  // If user is logged in, redirect to overview
  if (!loading && user) {
    return <Navigate to="/overview" replace />;
  }

  return (
    <div className="page-wrapper">
      <div className="main-wrapper _100vh">
        <Navbar />
        <div className="section-auth">
          <div className="container-medium z-index-2">
            <Outlet />
          </div>
        </div>
        <div className="spacer-medium"></div>
        <div className="absolute-footer-wrapper">
          <Footer />
        </div>
      </div>
    </div>
  );
}
